// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import { createBrowserRouter, Navigate, RouterProvider } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import 'bootstrap/dist/css/bootstrap.min.css';
import './styles/App.css';
import App from './App';
import Home from './pages/Home';
import UserList from './pages/Users/List';
import UserLogin from './pages/Users/Login';
import UserRegister from './pages/Users/Register';
import UserDashboard from './pages/Users/Dashboard';
import DocumentList from './pages/Documents/List';
import DocumentCategories from './pages/Documents/Categories';
import UniversityList from './pages/Universities/List';
import UniversityImport from './pages/Universities/Import';
import UnitCommittee from './pages/Committees/Unit';
import StateCommittee from './pages/Committees/State';
import ExecutiveCommittee from './pages/Committees/ExecutiveCommittee';
import OfficeBearer from './pages/Committees/OfficeBearer';
import Gallery from './pages/Gallery';
import PrivateRoute from './components/PrivateRoute';
import NewsList from './pages/NewsList';
// Add Committee imports
import SecretaryList from './pages/Committees/SecretaryList';
import PresidentList from './pages/Committees/PresidentList'; // New import
import UpdatePassword from './pages/Users/UpdatePassword';

const router = createBrowserRouter([
  {
    path: '/',
    element: <App />,
    children: [
      { index: true, element: <Home /> },
      { path: 'users/login', element: <UserLogin /> },
      { path: 'users/register', element: <UserRegister /> },
      {
        path: 'users',
        element: <PrivateRoute><UserList /></PrivateRoute>
      },
      {
        path: 'users/dashboard',
        element: <PrivateRoute><UserDashboard /></PrivateRoute>
      },
      {
        path: 'documents',
        element: <PrivateRoute><DocumentList /></PrivateRoute>
      },
      {
        path: 'document-categories',
        element: <PrivateRoute><DocumentCategories /></PrivateRoute>
      },
      {
        path: 'universities',
        element: <PrivateRoute><UniversityList /></PrivateRoute>
      },
      {
        path: 'universities/import',
        element: <PrivateRoute><UniversityImport /></PrivateRoute>
      },
      {
        path: 'unitcommittee',
        element: <PrivateRoute><UnitCommittee /></PrivateRoute>
      },
      {
        path: 'statecommittee',
        element: <PrivateRoute><StateCommittee /></PrivateRoute>
      },
      {
        path: 'executivecommittee',
        element: <PrivateRoute><ExecutiveCommittee /></PrivateRoute>
      },
      {
        path: 'officebearer',
        element: <PrivateRoute><OfficeBearer /></PrivateRoute>
      },
      {
        path: 'gallery',
        element: <PrivateRoute><Gallery /></PrivateRoute>
      },
      {
        path: 'news',
        element: <PrivateRoute><NewsList /></PrivateRoute>
      },
      // Committee routes
      {
        path: 'secretary',
        element: <PrivateRoute><SecretaryList /></PrivateRoute>
      },
      // Add President route
      {
        path: 'president',
        element: <PrivateRoute><PresidentList /></PrivateRoute>
      },
      // Add President route
      {
        path: '/users/settings',
        element: <PrivateRoute><Navigate to="/users/update-password" replace /></PrivateRoute>
      },
      {
        path: '/users/update-password',
        element: <PrivateRoute><UpdatePassword /></PrivateRoute>
      },
    ]
  }
]);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <RouterProvider router={router} />
    </AuthProvider>
  </React.StrictMode>
);
